import { render, staticRenderFns } from "./mailparser.vue?vue&type=template&id=4c8af5aa&scoped=true&"
import script from "./mailparser.vue?vue&type=script&lang=js&"
export * from "./mailparser.vue?vue&type=script&lang=js&"
import style0 from "./mailparser.vue?vue&type=style&index=0&id=4c8af5aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8af5aa",
  null
  
)

export default component.exports